class OrderCheckoutPromocodeSection {
    /**
     * @param {jQuery} $section
     * @param {Object} options
     * @param {PageOrderCheckout} options.order_checkout
     * @param {Function?} options.onApplyCode
     * @param {Function?} options.onCancelCode
     * */
    constructor($section, options) {
        const that = this;

        // DOM
        that.$section = $section;
        that.$form = that.$section.find('.js-promocode-form');
        that.$input = that.$form.find('.js-promocode-input');
        that.$apply_button = that.$form.find('.js-promocode-apply-button');
        that.$cancel_button = that.$form.find('.js-promocode-cancel-button');

        // CONST
        that.order_checkout = options.order_checkout;

        /**
         * @type {Function}
         * */
        that.onApplyCode = (typeof options.onApplyCode === 'function' ? options.onApplyCode : function() {});
        /**
         * @type {Function}
         * */
        that.onCancelCode = (typeof options.onCancelCode === 'function' ? options.onCancelCode : function() {});

        // VARS
        that.is_locked = false;

        that.tags_manager = that.#initTagsManager();

        that.init();
    }

    init() {
        const that = this;

        that.$form.on('submit', function(event) {
            event.preventDefault();
        });

        // Применить код
        that.$apply_button.on('click', function(event) {
            event.preventDefault();

            if (that.is_locked) { return false; }

            const code = $.trim(that.$input.val() || '');
            if (!code || !code.length) {
                UIInput.prototype.setError(that.$input);
                return false;
            }

            that.#applyCode(code);
        });

        // Отменить код
        that.$cancel_button.on('click', function(event) {
            event.preventDefault();

            if (that.is_locked) { return false; }

            const code = $.trim(that.$input.val() || '');
            if (!code || !code.length) {
                return false;
            }

            that.#cancelCode(code);
        });
    }

    clear() {
        const that = this;

        that.tags_manager.clear();

        that.#toggleButtons(false);
        that.#clearInput();
    }

    /**
     * @param {String} code
     * */
    renderCode(code) {
        const that = this;

        that.#toggleButtons(true);

        that.$input
            .val(code)
            .attr('value', code)
            .attr('disabled', true);
        
        that.tags_manager.toggle(false);

        UIInput.prototype.setNotEmpty(that.$input, !!code);
        UIInput.prototype.setSuccess(that.$input);
    }

    /**
     * @param {String?} message
     * */
    renderError(message) {
        const that = this;

        that.#toggleButtons(false);

        if (message) {
            UIInput.prototype.setError(that.$input, message);
            that.$input.trigger('focus');
        }
    }

    renderLoading(is_loading) {
        const that = this;

        that.$input.attr('disabled', !!is_loading);

        $.sa.buttonLoading(that.$apply_button, !!is_loading);
        $.sa.buttonLoading(that.$cancel_button, !!is_loading);
    }

    /**
     * @param {String} code
     * @param {Object?} options
     * @returns {jQuery.Promise}
     */
    #applyCode(code, options = {}) {
        const that = this;

        if (that.is_locked) { return false; }

        if (!code || !code.length) { return false; }

        if (options.update_input_value) {
            updateInputValue(code);
        }

        that.is_locked = true;

        that.renderLoading(true);

        return that.order_checkout.usePromocode(code)
            .always( function() {
                that.tags_manager.clear();
                that.renderLoading(false);
                that.is_locked = false;
            })
            .done( function() {
                that.tags_manager.setActive(code);
                that.renderCode(code);
                that.onApplyCode(code, that);
            })
            .fail( function(data) {
                if (data.clear) {
                    that.clear();
                } else {
                    that.renderError(data.message);
                }
            });

        function updateInputValue(code) {
            that.$input.val(code);
            UIInput.prototype.clearError(that.$input);
            UIInput.prototype.clearSuccess(that.$input);
            UIInput.prototype.setNotEmpty(that.$input, !!code);
        }
    }

    /**
     * @param {String} code
     * @returns {jQuery.Promise}
     */
    #cancelCode(code) {
        const that = this;

        if (that.is_locked) { return false; }

        if (!code || !code.length) { return false; }

        that.renderLoading(true);

        that.order_checkout.cancelPromocode(code)
            .always( function() {
                that.renderLoading(false);
                that.is_locked = false;
            })
            .done( function() {
                that.clear();
                that.onCancelCode(code, that);
            })
            .fail( function() {
                that.renderCode(code);
            });
    }

    /**
     * @param {Boolean} code_applied
     * */
    #toggleButtons(code_applied) {
        const that = this;

        if (code_applied) {
            that.$apply_button.hide();
            that.$cancel_button.show();
        } else {
            that.$apply_button.show();
            that.$cancel_button.hide();
        }
    }

    /**
     * @param {Object?} options
     * @param {Boolean?} options.value
     * @param {Boolean?} options.states
     * */
    #clearInput(options = {}) {
        const that = this;

        const clear_value = (typeof options.value === 'boolean' ? options.value : true),
              remove_states = (typeof options.states === 'boolean' ? options.states : true);

        that.$input
            .val('')
            .attr('value', '')
            .attr('disabled', false);

        if (clear_value) {
            UIInput.prototype.clearInput(that.$input);
        }

        if (remove_states) {
            UIInput.prototype.clearSuccess(that.$input);
            UIInput.prototype.clearError(that.$input);
        }
    }

    #initTagsManager() {
        const that = this;

        let result = {
            clear: function() {},
            toggle: function() {},
            setActive: function() {}
        };

        // Если промокодов в DOM нет, то ничего не делаем
        const $tags_wrapper = that.$section.find('.js-button-tags');
        if ($tags_wrapper.length) {
            result = initTags($tags_wrapper);
        }

        return result;

        /**
         * @returns {Object<result>}
         * */
        function initTags($tags_wrapper) {
            // DOM
            const $tags = $tags_wrapper.find('.js-button-tag.js-set-promocode');

            // VARS
            let is_displayed = true;

            // Если промокод уже активирован, то скрываем форму
            const current_code = that.$input.val();
            if (current_code) {
                toggle(false);
            }

            // Клик по промокоду
            $tags.on('click',function(event) {
                event.preventDefault();

                const code = $(this).val();
                that.#applyCode(code, { update_input_value: true });
            });

            // Возвращаем объект с методами для работы из-вне
            return { clear, toggle, setActive };
            
            // FUNCTIONS

            /**
             * @description снимает выделение с активного промокода и показывает список
             * */
            function clear() {
                UIButtonTags.clear($tags_wrapper);
                that.tags_manager.toggle(true);
            }

            /**
             * @description функция управляет отображением списка промокодов
             * @param {Boolean?} show
             * */
            function toggle(show = null) {
                if (typeof show !== 'boolean') {
                    show = !is_displayed;
                }

                if (show) {
                    $tags_wrapper.show();
                } else {
                    $tags_wrapper.hide();
                }

                is_displayed = show;
            }

            /**
             * @description ищет в списке промокод совпадающий со значением на входе и помечает его активным (только рендер)
             * @param {String} active_code
             * */
            function setActive(active_code) {
                $tags.each( function() {
                    const $button = $(this),
                          code = $button.val();

                    if (code === active_code) {
                        UIButtonTags.clear($tags_wrapper);
                        UIButtonTags.setActive($button);
                        return false;
                    }
                });
            }
        }
    }
}